import { createContext, useContext } from 'react';
import type { Rect } from '@/shared/ui/FloatingWindow';

/** Что окну известно о своём «хозяине» (менеджере окон): свёрнуто ли оно и как об этом сообщить. */
export interface WindowHost {
  minimized: boolean;
  minimize: () => void;
  /** Подпись окна для панели свёрнутых окон. */
  setLabel: (label: string) => void;
  /** Есть ли несохранённые изменения — отмечается точкой на плашке в панели свёрнутых окон.
   *  Вызывают только окна, которые сами отслеживают черновик (документ); остальные типы окон
   *  просто не вызывают — индикатора у них не будет. */
  setDirty: (dirty: boolean) => void;
  /** Растёт на каждое нажатие «Закрыть все» на панели свёрнутых окон — свёрнутое окно реагирует
   *  на изменение этого числа своим обычным `onClose` (с проверкой несохранённых изменений),
   *  развёрнутое окно сигнал игнорирует. */
  closeAllSignal: number;
  /** Растёт, когда именно ЭТО окно должно выйти на передний план программно (переключение между
   *  окнами по горячей клавише) — в отличие от клика, его не на что «навести». */
  focusSignal: number;
  /** Растёт, когда именно ЭТОМУ окну назначена новая позиция/размер («Разложить каскадом/сеткой»)
   *  — вместе с `arrangeRect`, который действителен только на момент, когда сигнал изменился. */
  arrangeSignal: number;
  arrangeRect: Rect | undefined;
}

const WindowHostContext = createContext<WindowHost | null>(null);

export const WindowHostProvider = WindowHostContext.Provider;

/** `null`, если окно рисуется вне менеджера окон (тогда сворачивание недоступно). */
export function useWindowHost(): WindowHost | null {
  return useContext(WindowHostContext);
}
